<template>
  <b-modal v-model="localValue" centered :cancel-disabled="cancelDisabled" no-close-on-esc no-close-on-backdrop :hide-header-close="!closable" :title="title" :hide-footer="hideFooter" :size="size" @hidden="$emit('hidden')">
    <div v-if="content" class="text-center" v-html="content">
    </div>
    <slot v-else></slot>
		<div v-if="!hideFooter" class="cookie-checkbox-ctn">
			<base-checkbox v-model="dontShowAgainChecked" v-if="dontShowAgainCookie" class="text-center mb-0">
				<span v-html="$t('dontShowAgain')"></span>
			</base-checkbox>
		</div>
    <template #modal-footer>
      <b-button v-if="okBtnVisible" :variant="okBtnVariant" @click="builtInOkFn()">
        {{ okBtnText || $t('dialog.ok-button') }}
      </b-button>
      <b-button v-if="cancelFn" :variant="cancelBtnVariant" @click="builtInCancelFn()">
        {{ cancelBtnText || $t('dialog.cancel-button') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import { getCookie, setCookie } from '@/helpers/cookies.helpers'

export default {
  name: 'base-dialog',
  components: {
    BModal,
    BButton,
    BaseCheckbox
  },
  props: {
    value: [Boolean],
    title: {
      type: String,
      required: false,
      default: null
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    okFn: {
      type: Function,
      required: false,
      default: null
    },
    cancelFn: {
      type: Function,
      required: false,
      default: null
    },
    okBtnVariant: {
      type: String,
      required: false,
      default: 'primary'
    },
    okBtnText: {
      type: String,
      required: false,
      default () {
        return this.$t('dialog.ok-button')
      }
    },
    cancelBtnVariant: {
      type: String,
      required: false,
      default: 'danger'
    },
    cancelBtnText: {
      type: String,
      required: false,
      default () {
        return this.$t('dialog.cancel-button')
      }
    },
    dontShowAgainCookie: {
      type: String,
      required: false
    },
		dontShowAgainCookieExpirationDays: {
			type: Number,
			required: false,
			default: 365
		},
		keepOpened: {
			type: Boolean,
			required: false,
			default: false
		},
		hideFooter: {
			type: Boolean,
			required: false,
			default: false
		},
		okBtnVisible: {
			type: Boolean,
			required: false,
			default: true
		},
		size: {
			type: String,
			required: false,
			default: 'lg',
			validator: (value) => {
				return ['sm', 'md', 'lg', 'xl'].includes(value)
			}
		},
    closable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      localValue: false,
      dontShowAgainChecked: false
    }
  },
  methods: {
    builtInOkFn () {
      if (this.okFn) {
        this.okFn()
      }
			this.processDontShowAgainCookie()
      this.localValue = this.keepOpened || false
      this.$store.commit('hideSharedDialog')
    },
    builtInCancelFn () {
      if (this.cancelFn) {
        this.cancelFn()
      }
			if (!this.okBtnVisible) {
				this.processDontShowAgainCookie()
			}
      this.localValue = this.keepOpened || false
      this.$store.commit('hideSharedDialog')
    },
		processDontShowAgainCookie () {
			if (this.dontShowAgainChecked) {
				setCookie(this.dontShowAgainCookie, true, this.dontShowAgainCookieExpirationDays)
			}
		}
  },
  computed: {
    cancelDisabled () {
      return !this.cancelFn
    }
  },
  created () {
    this.localValue = this.value && getCookie(this.dontShowAgainCookie) !== 'true'
    this.$watch('value', value => {
      this.localValue = value && getCookie(this.dontShowAgainCookie) !== 'true'
    })
    this.$watch('localValue', value => {
      this.$emit('input', value)
      this.$emit('change', value)
    })
  }
}
</script>

<style scoped lang="scss">
// /deep/ .modal-header .close {
//   display:none;
// }

/deep/ .cookie-checkbox-ctn {
	margin-bottom: -2.5rem;
  margin-top: 3rem;
}

/deep/ .modal-footer {
	padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/base/BaseDialog.vue